var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamsIllustation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1226,
    height: 772,
    viewBox: "0 0 1226 772",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 0.5C114 0.5 103.7 52.8879 120.501 115.5C18.3379 166.732 -4.40993 196.858 2.00144 252.5C2.79507 332.793 66.7464 364.547 52.0014 431.5C37.2565 498.453 -90.196 654.93 135.001 752H654.001C824.419 755.347 893 752 969 752C1026 743 1044.48 732.039 1082.5 705.5C1139.54 656.479 1164 576.5 1106 543C1095.5 507 1168 479.5 1175.5 431.5C1183 383.5 1114.5 317.5 1095.5 308C1024 152 1094.83 105.189 1026 71.5C941.918 41.5344 888.881 31.8562 779.001 33C665.785 43.6801 565.872 56.1678 541.501 51C427.509 41.7608 363.5 0.5 243.5 0.5Z",
    fill: "#EBF0FE",
    stroke: "#EAEFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M689.5 287C758.568 -45.1531 1033.92 78.7665 856.5 318.5C836.695 345.26 832.021 354.938 819.5 375C842.059 429.508 840.215 475.27 786.5 492.825C787.178 498.689 788.558 503.084 790.384 506.336C808.64 479.155 819.5 510.5 819.5 510.5C819.5 510.5 799.444 522.473 790.384 506.336C780.433 521.152 768.285 553.355 754.5 617.5C715.425 799.327 408.308 784.424 441 617.5C473.691 450.575 492.241 449.951 579.5 433.5C606.158 366.843 624.799 331.555 689.5 287Z",
    fill: "#33AA94",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 375C832.021 354.938 836.695 345.26 856.5 318.5C1033.92 78.7665 758.568 -45.1531 689.5 287C624.799 331.555 606.158 366.843 579.5 433.5C492.241 449.951 473.691 450.575 441 617.5C408.308 784.424 715.425 799.327 754.5 617.5C793.576 435.673 819.5 510.5 819.5 510.5C819.5 510.5 790.545 527.786 786.5 492.825M819.5 375C842.059 429.508 840.215 475.27 786.5 492.825M819.5 375L786.5 492.825",
    stroke: "#33AA94",
    strokeOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M673.712 450.738C723.74 364.999 772.522 274.576 828.792 183C780.186 271.181 736.665 353.047 683.028 446.941C619.303 553.673 596.757 644.441 540.349 729.801C593.388 638.491 615.666 549.427 673.712 450.738Z",
    fill: "#ECF1FE",
    stroke: "#ECF1FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M547.5 288.5C576.276 164.862 471.65 88.1101 411 288.5C405.819 305.618 402.5 333.5 402.5 333.5C341.566 377.291 323.067 405.73 329 470.5C304.14 476.225 293.839 483.875 282 505.5C282 505.5 280 550 242 640.5C204 731 390.5 769 441 675.5C491.5 582 517.632 533.241 517.5 425.5L547.5 288.5Z",
    fill: "#33AA94",
    fillOpacity: 0.2,
    stroke: "#33AA94",
    strokeOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.59 442.748C431.233 365.932 467.682 281.878 513.846 202C476.907 283.179 444.777 359.771 402.911 444.771C351.611 539.29 350.616 643.85 302.256 715.284C344.152 633.292 345.337 530.815 391.59 442.748Z",
    fill: "white",
    stroke: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1133 635.5C1112.71 572.465 1105.23 533.851 1162.5 418C1219.76 302.148 1133.15 276.262 1058.5 376.5C983.847 476.738 994.758 474.637 974.5 545.5C954.862 614.19 896.253 688.331 956 727.5C1027.5 774.371 1152.73 696.797 1133 635.5Z",
    fill: "#D5E2FD",
    stroke: "#D5E2FD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.53 575.131C1057.46 521.133 1077.85 462.401 1105.03 406C1084.16 462.812 1066.31 516.276 1042.3 575.924C1012.39 642.494 1017.03 713.301 987.931 764.099C1012.12 706.485 1007.71 637.077 1034.53 575.131Z",
    fill: "#B2CDFC",
    stroke: "#ECF1FE",
    strokeWidth: 0.678617
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1101 297C1126.67 228.512 1132.52 190.763 1135.5 124C1125.8 56.5051 1095.68 46.0125 993 81.5C938.44 113.195 908.651 131.516 877 179L865.5 297C865.5 297 894.5 367.5 865.5 421.5C836.499 475.5 807.781 483.015 776 531.5C759.453 614.91 768.501 654.058 806 715C865.686 760.588 903.599 760.723 979.5 715C1049.89 650.881 1042.78 609.138 1004.5 531.5L1101 297Z",
    fill: "#B2CDFC",
    stroke: "#B2CDFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M907.001 446C932.514 363.408 953.609 274.253 985.001 187.5C962.919 273.911 944.763 354.96 918.501 446C884.628 548.069 902.042 651.173 867.001 730C893.821 641.918 876.961 540.829 907.001 446Z",
    fill: "#ECF1FE",
    stroke: "#ECF1FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5006 256C20.0639 201.763 35.7625 174.788 89.5006 131C132.288 111.005 155.762 109.573 197.001 119C238.531 131.476 241.23 146.486 239.001 176L227.001 256L255.501 331C271.412 324.701 281.238 323.935 301.501 331C338.981 342.682 348.16 355.624 342 385.5C323.351 414.968 309.995 432.152 305 458.5C286.2 490.877 296.548 495.737 327.501 501C354.484 497.336 364.5 497.5 383.5 497.5C405.5 499.5 408.904 510.276 410.501 535C406.124 557.501 404.5 575 381.5 613C353.5 663.5 306.239 686.709 255.501 688.5C183.545 677.703 155.677 660.926 127.501 612.5L156.001 490C122.468 477.494 103 465.5 95 456C64.5 427.5 90.424 413.003 126.539 383.5L89.5006 306.5C63.3829 290.736 46.3086 286.091 28.5006 256Z",
    fill: "#B2CDFC",
    stroke: "#B2CDFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 408C168.823 327.971 151.772 278.475 121 191.5C158.752 272.304 180.042 314.967 217.5 402C256.071 502.388 270.576 550.837 293.5 634C258.35 548.899 238.441 500.36 201.5 408Z",
    fill: "#ECF1FE",
    stroke: "#ECF1FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1055 734L1043 733C1041.72 735.345 1041.32 737.298 1041.5 742.5C1047.16 746.786 1049.53 745.66 1053.5 742.5L1055 734Z",
    fill: "#AE332D",
    stroke: "#AE332D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M968 729.5C962.17 731.264 959.246 731.165 954.5 729.5C954.379 734.959 954.375 737.9 955.5 741C960.633 743.94 962.969 742.947 967 740.5C968.047 735.904 968.032 733.602 968 729.5Z",
    fill: "#AE332D",
    stroke: "#AE332D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M967.5 740.5C962.303 744.001 959.455 743.851 954.5 739.5C931.168 747.181 923.81 752.958 915.5 764.5C937.381 767.878 949.92 767.348 972.5 764.5C972.116 754.53 972.591 748.677 967.5 740.5Z",
    fill: "#4042E2",
    stroke: "#4042E2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M915.001 768.5C914.114 767.051 913.941 766.268 915.001 765H972.5C973.047 766.362 973.63 767.141 973.001 768.5H915.001Z",
    fill: "#0F0671",
    stroke: "#0F0671"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1074 765.5L1033.5 766.5C1033.21 768.112 1033.33 768.833 1034.5 769.5C1050.07 771.198 1058.6 771.024 1073.5 768.5C1074.27 767.636 1074.31 766.943 1074 765.5Z",
    fill: "#110775",
    stroke: "#110775"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.5 766.5C1032.54 758.24 1035.03 751.737 1040.5 739.5C1046.97 746.43 1050.24 747.309 1055 739.5C1070.64 749.786 1071.66 755.403 1073.47 765.321L1073.5 765.5C1058.52 767.409 1049.85 767.833 1033.5 766.5Z",
    fill: "#4042E2",
    stroke: "#4042E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.5 456.5L1060.5 447.5L1053.5 445.5L1051.5 456.5H1062.5Z",
    fill: "#AC322C",
    stroke: "#AC322C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M880.5 174.5C891.34 186.367 893.201 191.993 882 198.5L867 204.5L861.5 187.5L866.5 175.5C872.963 171.464 876.016 171.288 880.5 174.5Z",
    fill: "#AC322C",
    stroke: "#AC322C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1040 271.5H1003.5C991.32 271.265 983.79 272.912 970.5 275.5C950.051 279.417 939.548 278.866 922 274.5C891.728 255.676 880.393 240.964 881.5 199L867 205.5C854.756 278.03 862.339 312.618 951.5 342.5C958.14 394.423 963.767 422.878 981.5 471C1013.07 476.67 1028.01 475.858 1049.5 467L1076 345.5C1096.99 390.774 1089.25 412.233 1060.5 447.5L1063 456.5C1137.16 423.399 1171.71 400.98 1090.5 282.5C1087.4 278.591 1086.1 276.15 1079 274.5C1063.84 270.907 1055.31 269.977 1040 271.5Z",
    fill: "#33C4AA",
    stroke: "#33C4AA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1049.5 467.5C1023.57 476.676 1008.56 476.583 980.5 469C973.775 478.585 967.506 539.565 952.5 728.5C959.807 731.904 963.356 731.023 969.5 728.5C986.788 649.432 995.864 604.984 1011 525.5C1012.83 523.331 1013.62 524.038 1015 525.5C1024.56 605.725 1030.1 650.9 1040.5 732C1047.82 734.399 1051.73 734.548 1058.5 733.5C1062.72 628.541 1061.39 570.211 1049.5 467.5Z",
    fill: "url(#paint0_linear_154_419)",
    stroke: "#4648EE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1034 229.5H1028.5L1006.5 242.5C1005.23 253.019 1004.87 259.503 1004.5 271.5H1039.5C1037.21 254.142 1035.97 244.913 1034 229.5Z",
    fill: "#AA312B",
    stroke: "#AA312B"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M997.5 190.5C981.302 179.724 982.696 173.043 995.5 160.5C995.682 161.619 996.154 162.049 997.5 162.5H999C998.71 161.5 998.883 161.045 1000 160.5C1001.83 166.363 1009.24 167.985 1022 171C1040.06 175.643 1045.61 180.548 1047.5 193.5C1057.93 193.367 1062.22 199.313 1047.5 217.5V219.5C1051.37 226.855 1043.73 229.452 1031.5 229C1030.94 227.664 1030.81 226.842 1031.5 225C1039.67 217.602 1040.06 214.494 1036.5 210C1032.82 207.333 1030.66 209.029 1027 217.5C1027 217.5 1024.03 218.919 1025.5 216.5C1026.97 214.081 1028.94 205.608 1028 206.5C1027.59 202.063 1027.24 199.676 1022 199C1010.89 196.254 1005.66 194.343 997.5 190.5Z",
    fill: "#0D046A",
    stroke: "#0D046A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M989 235C986.457 214.304 990.448 206.016 998 191.5L1014.5 196.5L1027.5 201.5C1029.54 207.39 1027.71 211.306 1024.5 217.5H1027.5C1031.41 209.174 1033.48 208.026 1037 211.5C1038.77 216.64 1037.82 219.393 1031.5 224L1030.5 229C1022.97 240.221 1016.79 240.195 1006.5 242.5C992.969 244.307 987.587 243.758 989 235Z",
    fill: "#C0423C",
    stroke: "#C0423C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M508.5 741C508.085 737.344 507.993 735.237 509 731H522C522.15 735.252 521.571 737.528 520 741.5C515.377 744.93 512.819 745.958 508.5 741Z",
    fill: "#FEADAB",
    stroke: "#FEADAB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M500.5 768C500.211 767.024 500.087 766.476 500.5 765.5H539C539.603 766.476 539.558 767.024 539 768C524.212 769.97 515.806 770.17 500.5 768Z",
    fill: "#1A0F91",
    stroke: "#1A0F91"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M500.5 765C499.614 754.631 501.458 750.136 507.5 738C512.067 745.525 515.23 745.627 522 739.5C534.57 748.269 539.346 753.643 539 765H500.5Z",
    fill: "url(#paint1_linear_154_419)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M435.5 728.5L421.5 728C420.785 731.515 421.356 734.985 422 738.5C427.085 742.939 429.923 743.08 435 738.5C435.69 734.498 435.5 728.5 435.5 728.5Z",
    fill: "#FEADAB",
    stroke: "#FEADAB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M383.5 767.5V764.5L440 762.5V767.5H383.5Z",
    fill: "#1A0F91"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M383.5 764C393.218 751.189 400.931 745.269 421.5 738.5C428.757 744.206 431.27 742.338 435.5 738.5C438.976 748.027 440.709 753.373 439.5 763L383.5 764Z",
    fill: "url(#paint2_linear_154_419)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M515.5 471C491.073 478.835 476.847 478.91 447.5 474C430.473 571.648 424.228 627.853 419 729.5C426.224 731.92 430.277 731.666 437.5 729.5C453.458 649.952 476.932 527.871 478 526.5C479.068 525.129 479.744 525.32 481 526.5C489.918 611.939 496.371 653.971 507 732.5C513.638 734.182 517.36 734.079 524 732.5C529.416 628.62 528.919 571.092 515.5 471Z",
    fill: "url(#paint3_linear_154_419)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M605 170.5C602.347 164.528 601.202 160.953 592.5 159C584.94 162.354 581.729 165.033 579.5 172.5C576.02 183.139 580.076 183.726 586.5 185.5L605 170.5Z",
    fill: "#FF928E",
    stroke: "#FF928E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M372.5 195.5L364 185.5C364.757 171.034 370.439 166.762 384.5 162C390.379 167.296 392.312 171.442 395 179.5C387.272 187.478 382.362 191.045 372.5 195.5Z",
    fill: "#FF928E",
    stroke: "#FF928E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M507 278C493.557 283.359 485.934 285.61 471 278C448.758 277.52 437.222 279.086 418 284.5C377.687 268.691 367.169 249.881 372.5 196.5C370.395 190.721 369.167 187.531 363.5 185.5C326.287 253.452 326.449 288.623 418 342C425.365 393.606 432.8 423.2 448 474C479.576 479.453 495.431 479.997 516 470.5L516.401 468.162C525.385 415.788 530.67 384.975 545.5 342C636.665 295.29 636.455 264.44 620.5 208C613.665 204.8 609.834 204.941 603 208C603.407 253.046 590.526 268.12 549.5 281C534.167 278.808 525.166 277.904 507 278Z",
    fill: "#4E50FD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M457 192C458.756 196.441 461.128 197.069 465.5 198C471.945 200.192 475.552 200.001 482 198C483.813 201 485.444 202.653 490.5 205.5C487.697 210.067 487.324 212.465 488.5 216.5C489.218 222.578 491.167 224.197 496 225.5C501.696 224.634 504.616 223.57 509.5 221C515.857 215.645 516.424 212.313 509.5 205.5V201.5C512.632 196.279 513.142 193.486 509.5 189C504.977 184.738 501.553 183.643 492.5 186L484 183C483.402 177.447 482.114 175.142 477.5 173C472.813 170.818 470.189 170.431 465.5 173C460.035 176.311 458.331 178.543 457 183C456.004 186.184 455.753 188.072 457 192Z",
    fill: "#0A0160",
    stroke: "#0E056D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M471 278.5L473.5 251V237H500.5L507 278.5C493.408 283.932 485.617 285.048 471 278.5Z",
    fill: "url(#paint4_linear_154_419)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M471 278.5L473.5 251V237H500.5L507 278.5C493.408 283.932 485.617 285.048 471 278.5Z",
    fill: "black",
    fillOpacity: 0.06
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M480 198C474.909 199.203 471.88 199.661 464.5 198V206L463 213.5L461 224L459 233V240.5C459.741 244.626 460.864 246.534 464.5 249C469.602 250.106 472.573 250.597 480 249C484.485 247.965 485.998 247.141 488 245.5C492.555 242.199 494.016 240.185 496 236.5H501C504.256 235.226 505.485 234.451 507 233C509.638 229.333 510.155 227.685 510 225.5C510.557 221.799 510.293 220.432 508.5 219.5C505.964 218.253 504.267 218.408 501 219.5C497.884 220.557 496.877 221.971 496 225.5C492.38 223.05 490.538 221.333 488 217L491 206C487.873 201.981 485.689 200.061 480 198Z",
    fill: "#FEBBBA",
    stroke: "#FEBBBA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M751.5 194C730 191 716.608 192.871 723.5 218L751 309L723.5 441H789C807.427 432.44 811.217 422.685 811 400C810.055 385.993 814.204 381.96 822.5 375.5C842.62 360.63 843.111 344.157 829 303.5C822.465 294.216 818.63 289.014 799.5 280C794.449 279.23 791.929 277.82 789 270.5C788.021 255.851 786.79 247.894 782.5 234.5C774.259 217.558 773.5 204.5 751.5 194Z",
    fill: "url(#paint5_linear_154_419)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M764.001 596L740.501 594.5L750.501 730C746.322 742.278 733 763 734.5 762C736 761 764.001 742 764.001 742C765.394 738.071 766.174 735.988 767.501 732.5L764.001 730L773.001 640C774.724 618.662 773.235 608.652 764.001 596Z",
    fill: "#FEA9A7",
    stroke: "#FEA9A7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M770.5 770.5C775.918 748.52 776.636 739.806 771 735L768 733L764.5 742.5C753.317 750.047 746.741 753.654 734.5 762.5L726.5 764.5C723.058 766.843 723.921 768.157 726.5 770.5H743.5C752.037 760.761 757.063 754.403 763.5 752.5C768.144 754.356 768.119 760.449 768.5 770.5H770.5Z",
    fill: "#4547ED",
    stroke: "#4547ED"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M871 766.5C870.483 760.631 870.163 756.937 869.5 749L891.5 745.5C901.869 758.728 902.343 763.585 898.5 770L875 771C872.579 770.109 871.525 769.31 871 766.5Z",
    fill: "#4547ED",
    stroke: "#4547ED"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M862 713C838.249 664.572 824.973 638.141 801.5 594L827.5 587.5C858.295 612.309 862.927 652.442 876.5 713C882.86 729.217 886.989 738.807 894.5 754C890.869 762.905 886.45 764.068 872.5 757.5C868.362 740.913 866.481 731.256 862 713Z",
    fill: "#FEA9A7",
    stroke: "#FEA9A7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M725.5 298.5C673.947 270.534 652.328 247.605 617.5 203C618.665 186.356 614.967 179.563 604 170C595.797 174.277 591.415 177.047 586 186C588.774 204.28 597.252 203.322 607.5 209.5C627.676 252.318 641.299 276.838 694.5 327C710.868 306.196 718.214 298.698 725.5 298.5Z",
    fill: "#FEB1AF",
    stroke: "#FEB1AF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M856 208.5C849.357 200.558 846.841 195.797 845.5 186.5C856.114 171.809 860.648 174.799 869 178C873.839 186.04 873.043 191.818 866.5 204C897.881 313.013 853.954 338.274 767.5 361.5C763.49 350.772 769.884 341.084 782 323.5C844.126 311.817 854.169 280.478 856 208.5Z",
    fill: "#FEBBBA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M856 208.5C849.357 200.558 846.841 195.797 845.5 186.5C856.114 171.809 860.648 174.799 869 178C873.839 186.04 873.043 191.818 866.5 204M856 208.5L866.5 204M856 208.5C854.169 280.478 844.126 311.817 782 323.5C769.884 341.084 763.49 350.772 767.5 361.5C853.954 338.274 897.881 313.013 866.5 204",
    stroke: "#FEBBBA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M723.5 297.5L730.5 298.5C734.928 308.474 741.565 311.347 760.001 311C761.066 310.19 761.098 309.544 760.001 308C771.234 311.043 775.246 314.86 781.501 322.5C766.483 344.602 764.434 352.074 766.501 361L763.001 420C748.201 429.82 737.847 430.534 716.501 425L691.501 357C687.816 344.179 687.761 336.687 693.5 326.5C706.308 310.795 713.756 302.77 723.5 297.5Z",
    fill: "#00A3FF",
    stroke: "#4C4FFA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M763.5 419.5L716 425C709.924 450.973 712.239 466.925 721 496.5C728.567 536.519 732.429 557.932 740.5 594.5C776.047 599.167 795.018 597.208 827.5 587.5C814.487 558.249 808.064 539.957 802.5 494.5C800.194 450.357 792.064 433.456 763.5 419.5Z",
    fill: "#1A0F91",
    stroke: "#1A0F91"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M748 257C743.5 260.284 741.205 262.124 726.5 265.5L731 299C733.916 307.785 742.706 311.098 759.5 312L748 257Z",
    fill: "#FF928E",
    stroke: "#FF928E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M744 242C748.587 224.91 747.485 217.606 729.5 214.5C718.566 222.929 714.057 229.374 709.5 244.5C705.874 263.5 712.466 265.254 727.5 265C743.716 263.635 749.447 260.311 753.5 249.5C756.474 245.892 756.789 243.81 755 240C750.678 237.422 748.657 237.974 746 243L744 242Z",
    fill: "#FEAEAD",
    stroke: "#FEAEAD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5 261.5C163.207 239.307 177.089 217.445 203 175.5C210.961 166.968 221.165 165.065 230.5 166.6C249.864 169.926 255.404 181.221 244.5 197L230.5 243C239.429 241.336 240.777 256.396 244.5 277.5L271 325.5C289.633 374.288 290.362 402.586 237 452L164 469.5C135.366 474.779 129.353 458.203 129.5 407.5C127.682 396.577 124.256 388.793 119.104 382.5C106.615 375.396 85.8191 364.127 80.5 358.5C75.1808 352.873 67.342 349.999 62.5001 333C53.5314 310.063 62.4758 285.876 80.5001 274C87.1406 267.098 98.5587 265.695 111.5 261.5Z",
    fill: "#1A0F91"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M117.168 269.327C116.796 269.511 116.644 269.96 116.827 270.332C117.011 270.703 117.46 270.856 117.832 270.673L117.168 269.327ZM189.722 214.925C177.516 230.04 169.42 238.666 159.382 245.994C149.326 253.336 137.297 259.393 117.168 269.327L117.832 270.673C137.928 260.754 150.084 254.639 160.266 247.206C170.466 239.76 178.66 231.011 190.889 215.867L189.722 214.925Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7241 292.805C61.3302 323.072 68.7073 337.208 98.7241 359.805",
    stroke: "white",
    strokeWidth: 1.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M237.453 172.789C245.414 175.696 246.545 179.207 244.453 187.789",
    stroke: "white",
    strokeWidth: 1.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M220 584L194.5 586.5C185.42 601.104 182.466 612.559 188 649.5C191.075 678.35 192.306 694.929 194.5 724.5L191.5 728C192.708 735.908 206.892 745.092 228 760L209 724.5C212.616 671.89 215.281 641.291 220 584Z",
    fill: "#B13630",
    stroke: "#B13630",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 766.5C183.056 742.524 183.165 733.724 190.5 728.5C191.029 734.983 193.469 738.008 203.5 744C211.309 750.764 216.845 754.533 227.5 761L229 759.5C230.411 759.396 231.305 759.407 233 759.5C236.697 761.539 235.842 763.336 234.5 766.5H216L199.5 748.5H193.5L190.5 766.5H187.5Z",
    fill: "#110775",
    stroke: "#110775",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M157 582L130.5 577C108.931 597.273 99.591 609.8 94.5 641C87.3038 670.645 82.8176 687.581 74.5 718C68.2134 730.232 64.8363 737.584 59 751.5C70.4401 760.678 75.1669 758.973 82.5 751.5L91 718C113.016 665.43 127.864 635.595 157 582Z",
    fill: "#B13630",
    stroke: "#B13630",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4999 765.5C50.906 762.579 54.1594 755.515 63.5 739L57.9999 751.5C65.9311 759.817 71.0533 760.385 81.4999 754.5L85.4999 742C84.5345 754.26 84.7149 761.565 79.4999 765.5C70.7591 767.136 65.9412 767.201 57.4999 765.5Z",
    fill: "#110775",
    stroke: "#110775"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M268.5 308L239.5 274.5C292.649 251.486 313.083 227.56 347.5 182.5C348.903 175.119 349.714 171.078 350.5 164C354.011 157.673 356.06 154.588 361.5 150L365.5 153C379.613 148.329 385.056 148.954 388 159C390.979 164.628 391.087 168.128 388 175C384.069 177.259 381.715 177.917 376.5 175C372.811 180.582 370.375 182.714 365.5 185L358.5 189C336.766 235.782 318.128 261.861 268.5 308Z",
    fill: "#B33832",
    stroke: "#B33832",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M231.5 277C222.618 287.266 216.993 292.005 200 289.5C188.497 293.142 183.233 297.303 174 305C194.071 336.932 203.635 355.725 195.5 402.5C215.015 411.931 225.973 413.172 245.5 406C256.667 375.901 262.715 359.035 272.5 329C272.279 302.565 260.715 292.326 239 274.5L231.5 277Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M246 407C229.037 412.832 219.506 416.051 194.5 402.5C151.552 414.611 166.091 453.259 130 576.5C164.483 585.257 184.779 586.972 220.5 584C239.143 507.772 257.569 458.511 246 407Z",
    fill: "#33AA94",
    stroke: "#33AA94",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 341C197.908 314.501 193.424 306.741 174 306C127.443 401.669 109.29 427.313 86 451.5C69.3887 452.912 60.5292 454.582 44.5 459C41.4453 460.757 41.9119 461.743 44.5 463.5C63.1026 470.007 72.655 468.433 89 461.5C85.6364 473.613 84.9748 475.308 86 479.5L106 456.5C146.022 412.315 166.436 387.025 199.5 341Z",
    fill: "#B33832",
    stroke: "#B33832",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M234 242.5L212.5 234.5C206.434 256.537 204.343 268.844 201 289C217.076 291.747 221.768 287.119 229.5 277.5C231.001 265.17 232.025 257.294 234 242.5Z",
    fill: "#B33832",
    stroke: "#B33832",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M219 217.5C216.109 195.687 220.499 190.462 238.5 193C248.023 202.587 251.798 209.619 253 228C251.975 247.56 243.321 248.337 219 238.5C212.483 233.824 209.739 231.037 208 225.5C202.156 218.831 200.225 215.495 205 212C211.697 208.656 212.674 213.492 215.5 219.5L219 217.5Z",
    fill: "#AC322C",
    stroke: "#AC322C",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_419",
    x1: 1006.59,
    y1: 467.5,
    x2: 1006.59,
    y2: 734.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192723,
    stopColor: "#160B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09005D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_154_419",
    x1: 519.654,
    y1: 738,
    x2: 519.654,
    y2: 765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192723,
    stopColor: "#160B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09005D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_154_419",
    x1: 411.692,
    y1: 738.5,
    x2: 411.692,
    y2: 764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192723,
    stopColor: "#160B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09005D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_154_419",
    x1: 473.114,
    y1: 471,
    x2: 473.114,
    y2: 733.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192723,
    stopColor: "#160B85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09005D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_154_419",
    x1: 466,
    y1: 257.5,
    x2: 511.5,
    y2: 260,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500027,
    stopColor: "#FEB4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_154_419",
    x1: 780.2,
    y1: 192.923,
    x2: 780.2,
    y2: 441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894114,
    stopColor: "#7097C4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsIllustation);
export default __webpack_public_path__ + "static/media/teams Illustation.58554cd7461fb6c273623a0f35c34958.svg";
export { ForwardRef as ReactComponent };